import {
  getFetchedJSON,
  fetchWithState,
  fetchWithStateWithFixedToken,
} from '~/misc/fetch';
import {formatNumberOnly} from '~/misc/formatPhone';

export const getDirectOrderInfoApi = (getState, ID) => fetchWithState(getState, {
  method: 'GET',
  header: {
    'Cache-control': 'no-cache',
    'Pragma': 'no-cache',
  },
  url: `/tl/direct/order?account_id=${ID}`,
}).then(getFetchedJSON);

export const createOrderApi = (getState, val) => {
  const url = `/${val.userId}/vip/order`;
  const billInfo = {
    sc: val.salesCode || 'User',
    billing_info: {
      first_name: val.billFirstName || '',
      last_name: val.billLastname || '',
      phone: formatNumberOnly(val.billPhone) || '',
      email: val.billEmail || '',
      street_address: val.billAddress || '',
      city: val.billCity || '',
      state: val.billState || '',
      country: val.billCountry || '',
      zip: val.billZip || '',
    },
  };
  const product = {
    product: {
      seat_num: Number(val.user),
      origin_price: val.billingPlan.origin_price,
      show_name: val.billingPlan.show_name,
      discount_price: val.billingPlan.discount_price,
      pay_option: {
        key: val.billingPlan.key || '',
      },
    },
  };
  const reqestData = Object.assign(product, billInfo);
  reqestData['tl_account_id'] = val['id'] ? val['id'] : val['ID'];
  if (val['oldAccountId']){
    reqestData['tl_account_id'] = val['oldAccountId'];
  }
  return fetchWithStateWithFixedToken(
    getState,
    {
      method: 'POST',
      url: url,
      body: reqestData,
    },
    'customer_service_token'
  ).then(getFetchedJSON);
};

export const getPaymentInfoApi = (getState, val) => {
  const userID = getState().customerServicePaymentProcess.paymentOrderInfo.data.userId;
  const businessCode = val.business_code;
  const orderId = val.order_id;

  return fetchWithStateWithFixedToken(getState, {
    method: 'GET',
    header: {
      'Cache-control': 'no-cache',
      'Pragma': 'no-cache',
    },
    url: `/${userID}/orders?business_code=${businessCode}&order_id=${orderId}`,
  }, 'customer_service_token').then(getFetchedJSON);
};

export const createAccountPayOrderApi = (getState, val) => {
  const userID = getState().customerServicePaymentProcess.paymentOrderInfo.data.userId;
  val.account_id = userID;
  return fetchWithStateWithFixedToken(getState, {
    method: 'POST',
    url: `/${userID}/${val.business_code}/order/${val.order_id}/pay`,
    body: val,
  }, 'customer_service_token').then(getFetchedJSON);
};



// WEBPACK FOOTER //
// ./src/modules/customerServicePaymentProcess/api.js